import React from 'react';
import ImageGallerytechnicalcenter from '../components/ImageGallerytechnicalcenter';
import IRCTVDonationCard from "./IRCTVDonationCard";
import { useStats } from '../hooks/useStats';

const IRCTECHNICAL = () => {
    const technicalBaseAmount = 300;

  const { stats, loading } = useStats();

  // Format date for display
  const formatDisplayDate = (dateString) => {
    if (!dateString) return '31-Jan-2025';
    const date = new Date(dateString);
    const day = date.getDate();
    const month = date.toLocaleString('en-US', { month: 'short' });
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  // Format number with commas
  const formatNumber = (num) => {
    if (!num && num !== 0) return 'Loading...';
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  };

  const handlePhoneClick = (phoneNumber) => {
    const cleanedNumber = phoneNumber.replace(/\D/g, '');
    const telLink = `tel:${cleanedNumber}`;
    window.location.href = telLink;
  };

  if (loading) return <div className="loading">Loading statistics...</div>;

  return (
    <>
      <div className="about-us-container">
        <section className="activities-details">
          <button
            onClick={() => window.history.back()}
            style={{
              marginBottom: '10px',
              padding: '8px 10px',
              backgroundColor: '#255fe8',
              color: 'white',
              border: 'none',
              borderRadius: '5px',
              cursor: 'pointer',
              fontSize: '16px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            ← Back to All Activities
          </button>
          <div className="activity-intro">
            <h2>OUR ACTIVITIES</h2>
            <p>All praise and thanks are due to Allaah Subhaanahu wa Ta'ala, IRC - Islamic Research Centre Education & Welfare Trust is involved in the following Social, Welfare and Charitable activities</p>
          </div>
          <ImageGallerytechnicalcenter />

          {/* IRC Technical Institutes */}
          <div className="activity-card">
            <div className="activity-header">
              <h3>IRC TECHNICAL INSTITUTES (ITI)</h3>
            </div>
            <div className="activity-content">
              <p>Building Skilled Futures Through Free Technical Education
                For many underprivileged youth, access to technical education remains out of reach due to high costs and limited opportunities. IRC Technical Institutes (ITI) were established to break this barrier. With four centers across Baijipura, Lasur, Khuldabad, and Fazilpura, IRC has provided free skill-based training to 985 students as of July 2025.
                Each institute offers industry-relevant courses tailored to local needs. Students are trained in electrical maintenance, mobile and electronic gadget repair, AC servicing, tailoring, cake making, fashion designing, and computer literacy—all under the guidance of skilled instructors. Our latest center in Fazilpura offers cutting-edge IT training in fields like Data Science, AI, Digital Marketing, and Full Stack Development, opening doors to professional tech careers even for students from modest backgrounds.
                Every course completed brings a student closer to self-reliance, income stability, and dignity. Your support helps us equip them with tools not just for employment, but for transformation. Invest in skills, and you invest in futures.
              </p>

              <div className="clinic-card">
                <h4>Institute - 1 - Baijipura</h4>
                <p><strong>Name:</strong> IRC Technical Institute</p>
                <p><strong>Address:</strong> 3rd Floor, IRC Community Centre, Gali No 34, Behind Sikandar Function Hall, Apex Hospital Road, Baijipura, Chhatrapati Sambhajinagar (Aurangabad) - 431001</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 07-Jan-2020</p>
                <p><strong>Courses Offered:</strong> Mobile Repair, Electronic Gaget Repair, Electrician, AC Repair etc.</p>
                <p><strong>No. of Students Admitted:</strong> {formatNumber(stats.technical_baijipura_students)} (till {formatDisplayDate(stats.technical_baijipura_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('9112-9112-05')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    9112-9112-05
                  </span>
                </p>
              </div>

              <div className="clinic-card">
                <h4>Institute - 2 - Lasur</h4>
                <p><strong>Name:</strong> IRC Technical Institiute</p>
                <p><strong>Address:</strong> Gopinath Nagar, Mata Ramai Ambedkar Pravesh Dwar, Lasur Station, LASUR - 423702, Tal - Gangapur, Dist - Chhatrapati Sambhajinagar (Aurangabad)</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 14-Sep-2021</p>
                <p><strong>Courses Offered:</strong> Tailoring, Fashion Designing, Mehendi, Caligraphy, Cake Making etc.</p>
                <p><strong>No. of Students Admitted:</strong> {formatNumber(stats.technical_lasur_students)} (till {formatDisplayDate(stats.technical_lasur_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('9112-9112-03')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    9112-9112-03
                  </span>
                </p>
              </div>

              <div className="clinic-card">
                <h4>Institute - 3 - Khuldabad</h4>
                <p><strong>Name:</strong> IRC Technical Institiute</p>
                <p><strong>Address:</strong> Munam Masjid, Old Bus Stand, KHULDABAD - 431101, Dist - Chhatrapati Sambhajinagar (Aurangabad)</p>
                <p>
                  <strong>Location: </strong>
                  <a href="https://www.google.com/maps/place/Apex+Superspeciality+Hospital/data=!4m7!3m6!1s0x3bdba298d50bd2af:0xc79047004783e9a6!8m2!3d19.8812498!4d75.3471543!16s%2Fg%2F11byp6kfwk!19sChIJr9IL1Zii2zsRpumDRwBHkMc?authuser=0&hl=en&rclk=1" target="_blank" rel="noopener noreferrer">
                    📍Click here for Location
                  </a>
                </p>
                <p><strong>Date of Inauguration:</strong> 03-Feb-2022</p>
                <p><strong>Courses Offered:</strong> Tailoring, Fashion Designing, Mehendi, Caligraphy, Cake Making etc.</p>
                <p><strong>No. of Students Admitted:</strong> {formatNumber(stats.technical_khuldabad_students)} (till {formatDisplayDate(stats.technical_khuldabad_date)})</p>
                <p>
                  <strong>Contact No: </strong>
                  <span
                    className="contact-number"
                    onClick={() => handlePhoneClick('9112-9112-04')}
                    style={{ cursor: 'pointer', color: 'blue', textDecoration: 'underline' }}
                  >
                    9112-9112-04
                  </span>
                </p>
              </div>
              <div className="benefits-breakdown">
                <h4>What Your Donation Provides</h4>
                <div className="benefits-grid">
                  <div className="benefit-item">
                    <span className="benefit-icon">🧵</span>
                    <span className="benefit-text">Tailoring & Fashion Training</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">🎨</span>
                    <span className="benefit-text">Calligraphy & Mehendi Classes</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">🍰</span>
                    <span className="benefit-text">Baking & Cooking Skills</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">📚</span>
                    <span className="benefit-text">Educational Materials</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">🕌</span>
                    <span className="benefit-text">Islamic Studies & Arabic</span>
                  </div>
                  <div className="benefit-item">
                    <span className="benefit-icon">💼</span>
                    <span className="benefit-text">Career Counseling</span>
                  </div>
                </div>
              </div>
            </div>
            <IRCTVDonationCard
              title="IRC TECHNICAL INSTITUTES (ITI)"
              baseAmount={technicalBaseAmount}
              subtitle="Your donation makes a difference"
              description="Donate Us continue providing quality content and services to our community."
              amount="₹5000"
              purpose="Cause: IRC TECHNICAL INSTITUTES (ITI)"
            />
          </div>
        </section>
      </div>
    </>
  );
};

export default IRCTECHNICAL;